<template>
  <div v-if="page">
    <div :class="['page', slug]">
      <Header :id="page.header.id" :currentPage="slug" v-if="page.header" />
      <div class="content">
        <h1 v-if="page.title" class="content-title">{{page.title}}</h1>
        <template v-for="(block, index) in page.content">
          <RichText :id="block.id" :key="index" v-if="block.__typename === 'RichTextRecord'" />
          <Social :className="slug + '-page-social'" :id="block.id" :key="index" v-if="block.__typename === 'SocialContentRecord'" />
          <CallToAction :id="block.id" :key="index" v-if="block.__typename === 'CallToActionRecord'" />
          <HeroWidget :id="block.id" :key="index" v-if="block.__typename === 'HeroPostsWidgetRecord'" />
          <LatestPostsWidget :context="slug" :id="block.id" :key="index" v-if="block.__typename === 'LatestWidgetRecord'" />
        </template>
      </div>
      <Footer :id="page.footer.id" v-if="page.footer" />
    </div>
  </div>
</template>

<script>
import Header from 'components/Header.vue'
import Footer from 'components/Footer.vue'
import RichText from 'components/RichText.vue'
import Social from 'components/Social.vue'
import CallToAction from 'components/CallToAction.vue'
import HeroWidget from 'components/HeroWidget.vue'
import LatestPostsWidget from 'components/LatestPostsWidget.vue'

import gql from 'graphql-tag'

export default {
  name: 'Page',
  components: {
    Header,
    Footer,
    RichText,
    Social,
    CallToAction,
    HeroWidget,
    LatestPostsWidget
  },
  props: [
    'slug'
  ],
  data() {
    return {
      page: {}
    }
  },
  metaInfo () {
    return {
      title: this.metaTitle ? this.metaTitle : 'Vuletic Dragan',
      meta: [
        { name: 'description', content: this.metaDescription }
      ]
    }
  },
  computed: {
    metaTitle() {
      if (!this.page) return '';
      if (!this.page.seo || !this.page.seo.title) return this.page.title;
      return this.page.seo.title;
    },
    metaDescription() {
      if (!this.page || !this.page.seo || !this.page.seo.description) return '';
      return this.page.seo.description;
    }
  },
  apollo: {
    page: {
      query: gql`query Page ($slug: String) {
        page ( filter: { slug: { eq: $slug } } ) {
          _modelApiKey
          title
          header { id }
          content {
            ... on RichTextRecord { id }
            ... on SocialContentRecord { id }
            ... on CallToActionRecord { id }
            ... on HeroPostsWidgetRecord { id }
            ... on LatestWidgetRecord { id }
          }
          footer { id }
          seo {
            description
            title
          }
        }
      }`,
      variables() {
        return {
          slug: this.slug
        }
      },
      prefetch({route}) {
        return {
          slug: route.params.slug
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/assets/styles/breakpoints.less";

.content {
  background-color: #ffffff;
  padding: 10px 20px;
  display: flow-root;

  & h1.content-title {
    margin: 0.2em 0;
    padding: 0;
    font-family: LeagueGothicRegular,Arial,sans-serif;
    font-size: 30px;
    line-height: 35px;
    font-weight: normal;
    text-transform: uppercase;
  }

  & /deep/ ul, /deep/ ol {
    font-size: 15px;
    line-height: 20px;
    margin: 10px 0;
    padding: 0 0 0 40px;
    color: #0F0F0F;
    list-style: circle outside none;

    & li {
      padding: 0;
      color: #0F0F0F;
      margin: 0.2em 0;
    }
  }

  & /deep/ ol {
    list-style: decimal outside none;
  }

  & /deep/ a {
    color: #006699;
    text-transform: none;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  & /deep/ p {
    font-size: 15px;
    line-height: 20px;
    margin: 1.2em 0;
    padding: 0;
  }

  & /deep/ .about-page-social-item {
    padding-left: 20px;

    & .about-page-social-label {
      color: #959595;
      font-size: 28px;
      margin: 5px 0;
    }

    & .about-page-social-value {
      padding-left: 20px;
      margin: 5px 0;

      & p {
        margin: 5px 0;
      }

      & h3 {
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 0;
        margin-top: 10px;
      }
    }
  }
}
/deep/ .home {
  & .moto {
    width: 48%;
    display: inline-block;
    vertical-align: top;
    margin-left: 2%;

    & p {
      padding-left: 60px;
      font-size: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    & blockquote {
      margin: 10px 50px 10px 0;
      padding: 10px 10px 10px 60px;
      border-left: 3px solid #EFEFEF;
      background: none;

      & ul {
        margin: 0;
        list-style-image: none;
        list-style-position: outside;
        list-style-type: disc;
        padding: 0 0 0 10px;

        & li {
          color: #959595;
          letter-spacing: 2px;
          text-transform: capitalize;
          font-size: 14px;
          line-height: 22px;
        }
      }
    }
  }

  & .latest-posts {
    display: inline-block;
    width: 49%;

    & img {
      max-width: 100%;
    }

    & h2 {
      font-family: 'LeagueGothicRegular';
      font-size: 20px;
      font-weight: normal;
      text-transform: uppercase;
      padding: 10px 20px;
      margin: 0;
    }

    & p {
        margin: 0;
        padding: 10px 20px;
        font-size: 12px;
        line-height: 1.25;
    }
  }

  & .hero-widget .item {
    display: flex;
    background-repeat: no-repeat;
    background-size: cover;

    & h1 {
      font-family: LeagueGothicRegular;
      font-size: 51px;
      font-weight: normal;
      margin: 0 0 20px;
      text-transform: capitalize;

      & a {
        color: #0F0F0F;

        &:hover {
          color: #959595;
          text-decoration: none;
        }
      }
    }

    & h2 {
      font-family: LeagueGothicRegular;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      text-transform: uppercase;
    }

    & ul {
      font-family: LeagueGothicRegular;
      font-size: 24px;
      line-height: 1.25;
      font-weight: normal;
      margin: 0;
      text-transform: lowercase;
      list-style-image: none;
      list-style-position: outside;
      list-style-type: none;
      padding: 0 0 0 10px;

      & li {
        color: #959595;
        padding: 0 0 0 10px;
      }
    }
  }

  & .slogan {
    border-bottom: 5px solid #EFEFEF;
    border-top: 5px solid #EFEFEF;
    padding: 20px;
    position: relative;
    margin-bottom: 50px;

    & p {
      font-size: 28px;
      line-height: 33px;
      margin: 0;
    }
  }
}

@media @for-phone {
  /deep/ .home {
    & .latest-posts {
      width: 100%;
    }

    & .moto {
      width: 100%;
      margin: 0;

      & blockquote {
        padding: 20px;
        border: 0;
        margin: 0;
      }

      & p {
        padding: 0 20px;
        font-size: 15px;
      }
    }

    & .hero-widget .item {
      background-image: none !important;

      & h1 {
        font-size: 35px;
      }
      & .item-description {
        display: none;
      }
    }

    & .slogan p {
      font-size: 18px;
      line-height: 25px;
    }
  }
}
</style>
